import React, { useCallback, useEffect } from "react";
import { Card, Row, Col, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../directIncomeBalanceSlice";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import { SearchOutlined } from "@ant-design/icons";
import {
  fetchDirectIncomeBalance,
  fetchDirectIncomeAccountsBySearch,
} from "../directIncomeBalanceThunk";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const DirectIncomeBalanceFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.directIncomeBalance);
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    const dateFrom = searchParams.get("dateFrom");
    const dateTo = searchParams.get("dateTo");

    if (dateFrom && dateTo) {
      const dateFilters = {
        filterType: "All Income Account",
        accId: null,
        fromDate: dateFrom,
        toDate: dateTo,
      };
      dispatch(setFilters(dateFilters));
      dispatch(fetchDirectIncomeBalance({ filters: { ...filters, ...dateFilters } }));
      return;
    }

    const path = pathname.split("/")[3];
    if (path) {
      handleFilterChange("filterType", "Date Wise");
      handleFilterChange("toDate", path);
      handleSubmit();
    }
  }, []);

  const handleFilterChange = (field, value) => {
    if (field === "filterType") {
      dispatch(setFilters({ accId: null }));
    }
    dispatch(setFilters({ [field]: value }));
  };

  const searchAccount = useCallback(
    (text) => dispatch(fetchDirectIncomeAccountsBySearch(text)),
    [dispatch]
  );

  const handleSubmit = () => {
    if (!filters.filterType) {
      messageApi.warning("Select Filter Type");
      return;
    }
    dispatch(fetchDirectIncomeBalance({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch report ❌");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row
        gutter={[16, 16]}
        align="middle"
        wrap
        style={{ alignItems: "center" }}
      >
        {/* Filter Type */}
        <Col xs={24} sm={12} md={4} lg={6} xl={4}>
          <label>Filter Type</label>
          <SearchListAutoComplete
            id="rc_select_1"
            optionsList={[
              {
                sale_id: "All Income Account",
                display_text: "All Income Account",
              },
              {
                sale_id: "Income Account Wise",
                display_text: "Income Account Wise",
              },
            ]}
            value={
              filters.filterType
                ? { value: filters.filterType, label: filters.filterType }
                : undefined
            }
            onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("filterType", null);
                return;
              } 
              handleFilterChange("filterType", obj?.sale_id);
            }}
            placeholder="Filter Type"
            showAddNew={false}
          />
        </Col>

        {/* Account dropdown when Account Wise */}
        {filters.filterType === "Income Account Wise" && (
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <label>Search Account</label>
            <SearchListAutoComplete
              entityType="account"
              id="rc_select_1"
              searchThunk={searchAccount}
              resultSelector={(state) =>
                state.directIncomeBalance.incomeAccounts
              }
              onSelect={(obj) => handleFilterChange("accId", obj?.sale_id)}
              placeholder="Account"
              showAddNew={false}
            />
          </Col>
        )}

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          xs={24}
          sm={12}
          md={8}
          lg={6}
          xl={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            block
            style={{height: 35.19}}
            data-testid="report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }      
  `}</style>
    </Card>
  );
};

export default DirectIncomeBalanceFilters;
